import objectOrder from '@/api/report/object-order'

export const state = {}
export const getters = {}
export const mutations = {}

export const actions = {
  getObjectOrder(context, params) {
    const queryParams = params && params.params ? params.params : params
    return objectOrder.index(queryParams)
  },
  storeObjectOrder(context, data) {
    return objectOrder.store(data)
  },
  updateObjectOrder(context, { id, data }) {
    return objectOrder.update(id, data)
  }
}